"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.filterValue = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _react = _interopRequireDefault(require("react"));
var _reactCustomScrollbars = _interopRequireDefault(require("react-custom-scrollbars"));
var _HiSelectableList = _interopRequireDefault(require("../HiSelectableList"));
var _HiInput = _interopRequireDefault(require("../HiForm/HiInput"));
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
var _helpers = require("../utils/helpers");
var _keycode = _interopRequireDefault(require("keycode"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = exports.styles = function styles(theme) {
  return {
    labelIcon: {
      marginRight: 10
    },
    labelImg: {
      height: 18,
      width: 'auto',
      margin: '0 4px',
      verticalAlign: 'middle'
    },
    selectIconLabel: (0, _objectSpread2.default)({
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      paddingRight: 16
    }, theme.typography.body2, {
      display: 'inline-flex',
      width: '100%'
    }),
    selectImgLabel: (0, _objectSpread2.default)({
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      paddingRight: 16
    }, theme.typography.body2, {
      display: 'inline-flex',
      width: '100%'
    })
  };
};
var filterValue = exports.filterValue = function filterValue(item, searchValue) {
  return searchValue === '' || (0, _helpers.foldAccents)(item.label.toString().toLowerCase()).search((0, _helpers.foldAccents)(searchValue.toLowerCase())) !== -1;
};

/**
 *
 * Utilisé pour tous types de selects dans les formulaires.
 * - single / multiple ( multi-select )
 * - avec / sans checkboxes
 * - avec / sans barre de recherche
 * - avec / sans option "All"
 * - prise en compte du type des éléments (text, image, icon, ...)
 *
 * Ce composant réuni les sous-composants
 * - HiSelectInput : affiche l'élément dans le formulaire
 * - HiSearchField : intègre une barre de recherche dans le Popper, il filtre la liste des suggestions
 * - HiSelectableList : affiche la liste des suggestions selon le type des éléments
 */
var HiSelectContent = /*#__PURE__*/function (_React$PureComponent) {
  function HiSelectContent(props) {
    var _this;
    (0, _classCallCheck2.default)(this, HiSelectContent);
    _this = _callSuper(this, HiSelectContent, [props]);
    // Key down on list items
    _this.handleKeyDown = function (event) {
      var nextItem;
      var key = (0, _keycode.default)(event);
      if (key === 'down') {
        event.preventDefault();
        nextItem = (0, _helpers.getNextItemSelectable)(document.activeElement, 'down');
      } else if (key === 'up') {
        event.preventDefault();
        nextItem = (0, _helpers.getNextItemSelectable)(document.activeElement, 'up');
      } else if (key === 'tab' || key === 'esc') {
        _this.setState({
          open: false
        });
      } else if (key === 'space' || key === 'enter' && !_this.props.multiple) {
        event.preventDefault();
        var item = _this.props.options.find(function (elem) {
          return String(elem.id) === event.target.id;
        });
        _this.handleSelect(null, item);
      } else if (key === 'enter' && _this.props.multiple) {
        event.preventDefault();
        _this.handleClose();
      }
      if (nextItem) {
        nextItem.focus();
      }
    };
    // Key down on search input
    _this.handleKeyDownSearch = function (event) {
      var key = (0, _keycode.default)(event);
      if (_this.overlay && (key === 'down' || key === 'up')) {
        _this.focusOnFirstItem();
      } else if (_this.overlay && (key === 'esc' || key === 'enter')) {
        event.preventDefault();
        _this.handleClose();
      }
    };
    /**
     * Call onChange with the updated value
     *
     * - handle single value
     * - handle multiple value
     * - handle '_all' id
     *
     * @param event
     * @param item
     */
    _this.handleSelect = function (event, item) {
      var _this$props = _this.props,
        hasAll = _this$props.hasAll,
        multiple = _this$props.multiple,
        onChange = _this$props.onChange,
        options = _this$props.options,
        value = _this$props.value;
      if (!multiple) {
        // single value
        _this.handleClose();
        onChange(event, item.id, item);
      } else if (hasAll && item.id === '_all') {
        if (value.length === options.length) {
          // unselect _all options
          onChange(event, [], item);
        } else {
          // select _all options
          onChange(event, options.map(function (option) {
            return option.id;
          }), item);
        }
      } else if (value.includes(item.id)) {
        // unselect item
        onChange(event, value.filter(function (id) {
          return id !== item.id;
        }), item);
      } else {
        onChange(event, [].concat((0, _toConsumableArray2.default)(value), [item.id]), item);
      }
    };
    _this.handleClose = function () {
      if (_this.props.onClose) _this.props.onClose();
    };
    /**
     * Update suggestions list
     * - add '_no_result' item if suggestion list is empty
     * - add '_all' item if suggestion list is complete
     * @param suggestions
     */
    _this.handleSuggestions = function (suggestions) {
      var _this$props2 = _this.props,
        hasAll = _this$props2.hasAll,
        iconAll = _this$props2.iconAll,
        translations = _this$props2.translations;
      if (suggestions.length === 0) {
        // Add '_no_result' suggestion
        _this.setState(function (prevState) {
          return (0, _objectSpread2.default)({}, prevState, {
            suggestions: [{
              id: '_no_result',
              type: 'text',
              disabled: true,
              centered: true,
              hideCheckbox: true,
              label: translations.no_result_match
            }]
          });
        });
      } else {
        _this.setState({
          suggestions: [].concat((0, _toConsumableArray2.default)(hasAll ? [(0, _objectSpread2.default)({
            id: '_all',
            label: translations.all
          }, iconAll && {
            type: 'icon',
            icon: iconAll
          })] : []), (0, _toConsumableArray2.default)(suggestions))
        });
      }
    };
    /**
     * Call onScrollReachBottom
     * @param e
     */
    _this.handleScroll = function (e) {
      if (e.target.scrollHeight - e.target.clientHeight - e.target.scrollTop < 15) {
        _this.props.onScrollReachBottom();
      }
    };
    _this.handleSearch = function (e, inputValue) {
      var searchValue = inputValue && e.target.value ? inputValue : e.target.value;
      if (_this.props.onSearch) {
        _this.props.onSearch(e, searchValue);
      } else {
        _this.setState({
          searchValue: searchValue
        });
      }
    };
    _this.handleSearchReset = function () {
      _this.handleSearch({
        target: {
          value: ''
        }
      }, '');
    };
    /**
     * Build itemList & inputValue from select props
     * @param options
     * @param value
     * @param search
     * @param loading
     * @returns {{itemList: *[], inputValue: *}}
     */
    // eslint-disable-next-line no-unused-vars
    _this.buildSelectProps = function (options) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var search = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var loading = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      // build item list
      var itemList = [].concat((0, _toConsumableArray2.default)(loading ? [{
        id: '_loading',
        type: 'loader',
        disabled: true,
        centered: true,
        hideCheckbox: true,
        label: 'loading'
      }] : []), (0, _toConsumableArray2.default)(search !== '' ? (0, _toConsumableArray2.default)(options.filter(function (item) {
        return item.label && _this.props.filterFunc(item, search);
      })) : [].concat((0, _toConsumableArray2.default)(_this.props.hasAll ? [(0, _objectSpread2.default)({
        id: '_all',
        label: _this.props.translations.all
      }, _this.props.iconAll && {
        type: 'icon',
        icon: _this.props.iconAll
      })] : []), (0, _toConsumableArray2.default)(options))));
      return {
        itemList: itemList
      };
    };
    _this.getInputElement = function (el) {
      _this.searchField = el;
      if (_this.props.inputRef) {
        _this.props.inputRef(_this.searchField);
      }
    };
    _this.state = {
      open: false,
      focused: false,
      searchValue: props.searchValue ? undefined : '',
      suggestions: props.options
    };
    _this.handleSearch = _this.handleSearch.bind(_this);
    _this.handleSearchReset = _this.handleSearchReset.bind(_this);
    _this.handleSelect = _this.handleSelect.bind(_this);
    _this.handleSuggestions = _this.handleSuggestions.bind(_this);
    return _this;
  }
  (0, _inherits2.default)(HiSelectContent, _React$PureComponent);
  return (0, _createClass2.default)(HiSelectContent, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        loading = _this$props3.loading,
        options = _this$props3.options,
        searchable = _this$props3.searchable,
        type = _this$props3.type,
        value = _this$props3.value,
        multiple = _this$props3.multiple,
        translations = _this$props3.translations,
        hiSelectableListProps = _this$props3.hiSelectableListProps,
        onScrollReachBottom = _this$props3.onScrollReachBottom,
        startAdornment = _this$props3.startAdornment,
        _this$props3$searchVa = _this$props3.searchValue,
        searchValue = _this$props3$searchVa === void 0 ? this.state.searchValue : _this$props3$searchVa,
        _this$props3$buildSel = _this$props3.buildSelectProps,
        buildSelectProps = _this$props3$buildSel === void 0 ? this.buildSelectProps : _this$props3$buildSel,
        autoHeight = _this$props3.autoHeight,
        height = _this$props3.height;
      if (multiple) {
        if (!Array.isArray(value)) {
          throw new Error('HiPay Material-UI: the `value` property must be an array ' + 'when using the `HiSelect` component with `multiple`.');
        }
      }
      var selectedItemIdList = [];
      if (value) {
        selectedItemIdList = multiple ? (0, _toConsumableArray2.default)(value) : [value];
      }
      var _buildSelectProps = buildSelectProps(options, selectedItemIdList, searchValue, loading),
        itemList = _buildSelectProps.itemList;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !!searchable && /*#__PURE__*/_react.default.createElement(_HiInput.default, {
        value: searchValue,
        autoFocus: true,
        inputRef: this.getInputElement,
        onKeyDown: this.handleKeyDownSearch,
        onChange: this.handleSearch,
        onReset: this.handleSearchReset,
        placeholder: translations.search,
        startAdornment: 'search',
        tabIndex: 0
      }), startAdornment, /*#__PURE__*/_react.default.createElement(_reactCustomScrollbars.default, (0, _extends2.default)({
        ref: function ref(contentEl) {
          _this2.optionsContent = contentEl;
        }
      }, autoHeight ? {
        autoHeight: true,
        autoHeightMax: height
      } : {
        autoHeightMax: height,
        autoHeightMin: height
      }, {
        autoHeight: true,
        autoHeightMax: height // TODO ?
      }, onScrollReachBottom && {
        onScroll: this.handleScroll
      }), /*#__PURE__*/_react.default.createElement(_HiSelectableList.default, (0, _extends2.default)({
        type: type,
        itemList: itemList,
        onKeyDown: this.handleKeyDown,
        onSelect: this.handleSelect,
        selectedItemIdList: selectedItemIdList,
        fallbackImage: this.props.fallbackImage
      }, hiSelectableListProps))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.options !== prevState.suggestions) {
        return (0, _objectSpread2.default)({}, prevState, {
          suggestions: nextProps.options
        });
      }
      return null;
    }
  }]);
}(_react.default.PureComponent);
HiSelectContent.defaultProps = {
  autoHeight: true,
  height: 400,
  disabled: false,
  error: false,
  hasAll: false,
  hiSelectableListProps: {},
  hiSelectInputProps: {},
  multiple: false,
  searchable: false,
  translations: {
    all: 'All',
    no_result_match: 'No result match',
    search: 'Search',
    n_items_selected: '%s items selected',
    one_item_selected: '%s item selected',
    n_children: '%s items',
    one_child: '%s item'
  },
  type: 'text',
  filterFunc: filterValue
};
var _default = exports.default = (0, _withStyles.default)(styles, {
  hiComponent: true,
  name: 'HmuiHiSelectContent'
})(HiSelectContent);